import { Component, OnInit } from '@angular/core';

import { XmStore } from 'core/services';
import { StateService } from '@uirouter/core';

import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';
import { ProgressStatus } from 'my-account/constants';

@Component({
    selector: 'xm-addon-success',
    templateUrl: './addon-success.html',
    styleUrls: ['./addon-success.scss'],
    standalone: false
})

export class XmAddonSuccess implements OnInit {
    private addonsUtil: AddonsUtil;

    constructor(xmStore: XmStore, state: StateService, addonsUtil: AddonsUtil) {
        Object.assign(this, { xmStore, state, addonsUtil });
    }

    public ngOnInit(): void {
        this.addonsUtil.completeAddonsPolling(ProgressStatus.SUCCESS);
    }
}
